/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateTeamRequestBody = {
  name: string;
};

export type UpdateTeamRequest = {
  orgId: string;
  teamId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?: UpdateTeamRequestBody | undefined;
};

export type UpdateTeamTeam = {
  id: string;
  name: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * OK
 */
export type UpdateTeamResponseBody = {
  team: UpdateTeamTeam;
};

/** @internal */
export const UpdateTeamRequestBody$inboundSchema: z.ZodType<
  UpdateTeamRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
});
/** @internal */
export type UpdateTeamRequestBody$Outbound = {
  name: string;
};

/** @internal */
export const UpdateTeamRequestBody$outboundSchema: z.ZodType<
  UpdateTeamRequestBody$Outbound,
  z.ZodTypeDef,
  UpdateTeamRequestBody
> = z.object({
  name: z.string(),
});

export function updateTeamRequestBodyToJSON(
  updateTeamRequestBody: UpdateTeamRequestBody,
): string {
  return JSON.stringify(
    UpdateTeamRequestBody$outboundSchema.parse(updateTeamRequestBody),
  );
}
export function updateTeamRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTeamRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTeamRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTeamRequestBody' from JSON`,
  );
}

/** @internal */
export const UpdateTeamRequest$inboundSchema: z.ZodType<
  UpdateTeamRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => UpdateTeamRequestBody$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type UpdateTeamRequest$Outbound = {
  orgId: string;
  teamId: string;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?: UpdateTeamRequestBody$Outbound | undefined;
};

/** @internal */
export const UpdateTeamRequest$outboundSchema: z.ZodType<
  UpdateTeamRequest$Outbound,
  z.ZodTypeDef,
  UpdateTeamRequest
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => UpdateTeamRequestBody$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function updateTeamRequestToJSON(
  updateTeamRequest: UpdateTeamRequest,
): string {
  return JSON.stringify(
    UpdateTeamRequest$outboundSchema.parse(updateTeamRequest),
  );
}
export function updateTeamRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTeamRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTeamRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTeamRequest' from JSON`,
  );
}

/** @internal */
export const UpdateTeamTeam$inboundSchema: z.ZodType<
  UpdateTeamTeam,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
/** @internal */
export type UpdateTeamTeam$Outbound = {
  id: string;
  name: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
};

/** @internal */
export const UpdateTeamTeam$outboundSchema: z.ZodType<
  UpdateTeamTeam$Outbound,
  z.ZodTypeDef,
  UpdateTeamTeam
> = z.object({
  id: z.string(),
  name: z.string(),
  organizationId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export function updateTeamTeamToJSON(updateTeamTeam: UpdateTeamTeam): string {
  return JSON.stringify(UpdateTeamTeam$outboundSchema.parse(updateTeamTeam));
}
export function updateTeamTeamFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTeamTeam, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTeamTeam$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTeamTeam' from JSON`,
  );
}

/** @internal */
export const UpdateTeamResponseBody$inboundSchema: z.ZodType<
  UpdateTeamResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  team: z.lazy(() => UpdateTeamTeam$inboundSchema),
});
/** @internal */
export type UpdateTeamResponseBody$Outbound = {
  team: UpdateTeamTeam$Outbound;
};

/** @internal */
export const UpdateTeamResponseBody$outboundSchema: z.ZodType<
  UpdateTeamResponseBody$Outbound,
  z.ZodTypeDef,
  UpdateTeamResponseBody
> = z.object({
  team: z.lazy(() => UpdateTeamTeam$outboundSchema),
});

export function updateTeamResponseBodyToJSON(
  updateTeamResponseBody: UpdateTeamResponseBody,
): string {
  return JSON.stringify(
    UpdateTeamResponseBody$outboundSchema.parse(updateTeamResponseBody),
  );
}
export function updateTeamResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<UpdateTeamResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateTeamResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateTeamResponseBody' from JSON`,
  );
}
